import React from "react";

interface SvgStatisticArrowProps {
  color?: string;
  direction?: "up" | "down";
}

const SvgStatisticArrow: React.FC<SvgStatisticArrowProps> = ({
  color = "#005B68",
  direction = "up",
}) => {
  // Upward arrow path
  const upPath =
    "M1.3125 10.4999L5.25 6.56242L7.76208 9.0745C8.46423 7.69299 9.62743 6.53459 11.1535 5.85515L12.7522 5.14336M12.7522 5.14336L9.28645 3.81299M12.7522 5.14336L11.4218 8.6091";

  // Downward arrow path (pointing to the right)
  const downPath =
    "M3.3125 3.5001L7.25 7.43758L9.76208 4.9255C10.4642 6.30701 11.6274 7.46541 13.1535 8.14485L14.7522 8.85664M14.7522 8.85664L11.2865 10.18701M14.7522 8.85664L12.9218 5.3909";

  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d={direction === "down" ? downPath : upPath}
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default SvgStatisticArrow;
